/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon16Light = forwardRef('ArrowDCornerLeftDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 4.5A2.5 2.5 0 0 1 8.5 2h6a.5.5 0 0 1 0 1h-6A1.5 1.5 0 0 0 7 4.5v8.293l3.646-3.647a.5.5 0 0 1 .708.708l-3.652 3.651a1.7 1.7 0 0 1-2.404 0L1.646 9.854a.5.5 0 1 1 .708-.708L6 12.793V4.5Z" })));
});
